import {createAction, handleActions} from 'redux-actions';
import _ from 'lodash';
import Message from "../enums/Message";

// regular actions
const START_LOADING = '@translationtool/loading/START';
const END_LOADING = '@translationtool/loading/END';
const ADD_MESSAGE = '@translationtool/message/ADD';
const REMOVE_MESSAGE = '@translationtool/message/REMOVE';
const CLEAR_MESSAGES = '@translationtool/message/CLEAR';
const SET_HAS_UNSAVED_CHANGES = '@translationtool/message/SET_HAS_UNSAVED_CHANGES';
const SET_TEXT_INPUT = '@translationtool/textInput/SET';

const startLoading = createAction(START_LOADING);
const endLoading = createAction(END_LOADING);
const addMessage = createAction(ADD_MESSAGE, message => message);
const removeMessage = createAction(REMOVE_MESSAGE, message => message);
const clearMessages = createAction(CLEAR_MESSAGES);
const setHasUnsavedChanges = createAction(SET_HAS_UNSAVED_CHANGES, toggle => toggle);
const setTextInput = createAction(SET_TEXT_INPUT, input => input)

export const reducer = handleActions(
	{
		[START_LOADING]: (state) => {
			return {...state, isLoading: state.isLoading + 1};
		},
		[END_LOADING]: (state) => {
			return {...state, isLoading: state.isLoading - 1};
		},
		[ADD_MESSAGE]: (state, action) => {
			return {...state, messages: _.concat(state.messages, action.payload)};
		},
		[REMOVE_MESSAGE]: (state, action) => {
			return {...state, messages: _.without(state.messages, action.payload)};
		},
		[CLEAR_MESSAGES]: (state) => {
			return {...state, messages: []};
		},
		[SET_HAS_UNSAVED_CHANGES]: (state, action) => {
			return {...state, hasUnsavedChanges: action.payload};
		},
        [SET_TEXT_INPUT]: (state, action) => {
		    return {...state, textInput: action.payload}
        }
	},
	{
		isLoading: 0,
		hasUnsavedChanges: false,
		messages: [],
        textInput: ''
	}
);

const addMessageWrapper = message => dispatch => {
	dispatch(addMessage(message));
	if(message.type === Message.TYPE_INFO || message.type === Message.TYPE_WARNING){
		setTimeout(() => {
			dispatch(removeMessage(message));
		}, 3000);
	}
};

const setHasUnsavedChangesWrapper = toggle => dispatch => {
	if(toggle){
		window.onbeforeunload = function() {
			return true;
		};
	} else {
		window.onbeforeunload = null;
	}

	dispatch(setHasUnsavedChanges(toggle));
};

// public actions
export const actions = {
	startLoading,
	endLoading,
	addMessage: addMessageWrapper,
	removeMessage,
	clearMessages,
	setHasUnsavedChanges: setHasUnsavedChangesWrapper,
    setTextInput
};



// WEBPACK FOOTER //
// ./React/src/reducers/system.js